<i18n>
{
  "en": {
    "label": {
      "appName": "Verification System",
      "password": "New password (more than 8 characters)",
      "passwordConfirm": "New password (for confirmation)",
      "submitBtn": "Change password",
      "ok": "OK"
    },
    "message": {
      "progress": "Now processing..",
      "complete": "Password change is complete. Please log in from the login screen",
      "unexpectedError": "An unexpected error has occurred. Please try again later or send an email from the login screen again."
    }
  },
  "ja": {
    "label": {
      "appName": "手続きシステム",
      "password": "新しいパスワード(8文字以上)",
      "passwordConfirm": "新しいパスワード(確認用)",
      "submitBtn": "パスワードを変更する",
      "ok": "OK"
    },
    "message": {
      "progress": "処理中",
      "complete": "パスワードの変更が完了しました。ログイン画面からログインをお願いします",
      "unexpectedError": "予期せぬエラーが発生しました。時間をあけてお試し頂くか、再度ログイン画面からメールを送信下さい"
    }
  }
}
</i18n>

<template>
  <div>
    <Toolbar :title="title"></Toolbar>
    <br />
    <br />
    <v-container>
      <v-layout wrap justify-center text-xs-center>
        <v-flex sm12 md6 lg6 xl6>
          <form @submit.prevent>
            <TextInput
              name="password"
              type="password"
              :width="inputText.width"
              :color="inputText.color"
              v-model="password"
              :placeholderValue="this.$t('label.password')"
              v-validate.disable="{ required: true, min: 8 }"
              :readonly="inProgress"
            />

            <TextInput
              name="passwordConfirm"
              type="password"
              :width="inputText.width"
              :color="inputText.color"
              :placeholderValue="this.$t('label.passwordConfirm')"
              v-model="passwordConfirm"
              v-validate.disable="{ is: password }"
              :readonly="inProgress"
            />

            <SubmitBtn
              :disabled="inProgress"
              :colorCode="submitBtn.colorCode"
              @click="submitted"
              :autoSpread="true"
              :isDark="true"
              :hasOutline="false"
            >
              <strong>{{ $t('label.submitBtn') }}</strong>
            </SubmitBtn>
          </form>

          <span v-for="(error, key, index) in errors.all()" :key="index">
            <p class="vee-error" style="color: #F87060">{{ error }}</p>
          </span>
        </v-flex>
      </v-layout>

      <v-alert :value="errorMessages" type="error">
        <span v-for="error in errorMessages" :key="error.code">
          <span>{{ error.code }}</span
          ><br />
        </span>
      </v-alert>

      <v-progress-linear
        v-show="inProgress"
        :indeterminate="inProgress"
      ></v-progress-linear>

      <v-dialog v-model="finishDialog" max-width="400">
        <v-card>
          <v-card-text>
            {{ $t('message.complete') }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.prevent="moveToLogin()">
              {{ $t('label.ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import TextInput from '@/components/atoms/TextInput';
import SubmitBtn from '@/components/atoms/SubmitBtn';
import Toolbar from '@/components/molecules/Toolbar.vue';
import { Me } from '@/api';

export default {
  components: {
    TextInput,
    SubmitBtn,
    Toolbar
  },
  data() {
    return {
      password: '',
      passwordConfirm: '',
      inputText: {
        width: '80%',
        color: 'white'
      },
      submitBtn: {
        colorCode: 'primary'
      },
      inProgress: false,
      finishDialog: false,
      errorMessages: null
    };
  },
  computed: {
    title: function() {
      return (
        this.$store.getters.getCurrentCampaign.name + this.$t('label.appName')
      );
    }
  },
  methods: {
    processingOn() {
      this.inProgress = true;
    },
    processingOff() {
      this.inProgress = false;
    },
    moveToLogin() {
      this.finishDialog = false;
      this.$router.replace(`/cp/${this.$route.params.campaignCode}/login`);
    },
    submitted() {
      this.$validator.validate().then(result => {
        if (result !== true) {
          return;
        } // validationの結果をハンドリング
        this.processingOn(this.$t('message.progress'));
        this.$nextTick(function() {
          // 処理中フラグによるDOM制御を待つ
          Me.confirmPasswordChange(
            this.password,
            this.$route.params.passwordCode
          )
            .then(() => {
              this.processingOff();
              this.finishDialog = true;
            })
            .catch(ApiError => {
              this.processingOff();
              if (ApiError.errors) {
                this.errorMessages = ApiError.errors;
              } else {
                this.errorMessage = this.$t('message.unexpectedError');
              }
            });
        });
      });
    }
  },
  created() {
    this.$store.dispatch(
      'prepareByCampaignCode',
      this.$route.params.campaignCode
    );
  }
};
</script>
